import { useBillingPricing } from '@/api/hooks';
import { archivePackLine } from '@/lib/plan';

/**
 * "Need more archived rooms? Add 10 for $10/month." — the size and price are the
 * server's archive-pack catalogue (`GET /tenant/billing/pricing`), never written
 * here. Renders nothing until the price is known (or if it cannot be loaded).
 */
export function ArchivePackLine({ className }: { className?: string }) {
  const pricing = useBillingPricing();
  if (!pricing.data) return null;
  return <p className={className}>{archivePackLine(pricing.data.archivePack)}</p>;
}
